import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDoubleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.8 16.8 6 12l4.8-4.8m7.2 9.6L13.2 12 18 7.2"
    />
  </svg>
);
export default SvgChevronDoubleRight;
